import axios from 'axios'
import React, { createContext, useCallback, useEffect, useState } from 'react'
import { baseUrl } from './../utils/baseUrl';



export const ProductsContext = createContext(null)

export default function ProductsContextProvider(props) {

    const [products, setProducts] = useState([])
    const [totalPages, setTotalPages] = useState(1)
    const [count, setCount] = useState(1)
    const [query, setQuery] = useState('')
    const [sort, setSort] = useState('')

    const getData = useCallback(async (pageNum, query, sort) => {
        await axios.get(`${baseUrl}/products?page=${pageNum}&search=${query}&sort=${sort}`).then(response => {
            setProducts(response.data?.products)
            setTotalPages(response.data?.totalPages)
        }).catch(error => {
        })

    }, [])
    const getSearchQuery = (e) => {
        setQuery(e.target.value)
    }

    useEffect(() => {
        getData(count, query, sort)
    }, [getData, count, query, sort])

    function counterPrevPages() {
        const prevCount = count - 1
        if (!prevCount < 1) {
            setCount(prevCount);
        }
    }
    function counterNextPages() {
        const nextCount = count + 1
        if (nextCount > totalPages) {
        } else {
            setCount(nextCount);
        }
    }



    return (
        <ProductsContext.Provider value={{ products, count, totalPages, setSort, getSearchQuery, counterPrevPages, counterNextPages }} >
            {props.children}
        </ProductsContext.Provider>
    )
}
